import { render, staticRenderFns } from "./unionOverview.vue?vue&type=template&id=6212cabf&scoped=true"
import script from "./unionOverview.vue?vue&type=script&lang=js"
export * from "./unionOverview.vue?vue&type=script&lang=js"
import style0 from "./unionOverview.vue?vue&type=style&index=0&id=6212cabf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6212cabf",
  null
  
)

export default component.exports